export enum AppointmentActions {
    Reschedule = 1,
    Cancel = 2
}

export enum CommunicationMessageTypes {
    EmailTemplateMsg = "emailMsg",
    SmsTemplateMsg = "smsMsg",
    WhatsappTemplateMsg = "whatsappMsg",
    SubjectTemplateMsg = "SubjectMsg",
}



// WEBPACK FOOTER //
// ./src/app/shared/enum-files/general-enums.ts